import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/thumbs';
import 'swiper/css/zoom';
import 'swiper/css/free-mode';
// import './product.scss';
import { Zoom, Thumbs } from 'swiper/modules';
import NutritionalLabel from './nutritional_facts.js';
import '../styles/layout/product.scss';

import nf_thumb from '../images/nf_thumb.jpg';

//import {Zoom} from "reactjs-image-zoom";
//import Zoom from './img-zoom';
// const Product = () => {
//   return(
//       <h2>Testing</h2>
//   )
// }

const Product = (props) => {
  const [product, setProduct] = useState(null);
  //const [minHeight, setMinHeight] = useState(0);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [postID, setPostID] = useState(props.postid || null);

  console.log('Product');

  useEffect(() => {
      const root_el = document.querySelector("#render-react-product");
      if(postID === null && root_el){
        setPostID(root_el.dataset.postid);
      } 
    },[])

  useEffect(() => {
    // if(thumbsSwiper !== null){
    //   setThumbsSwiper(thumbsSwiper.destroy());
    // }
    if(props.product){
      setProduct(props.product);
    } 
  },[props])

  useEffect(() => {
      //fetch recipe .json using postID for root element
      console.log("postID", postID);
      const fetchProduct = async () => {
        try {
          const response = await fetch('/wp-json/wp/v2/product/'+postID+'?_embed');
          const data = await response.json();
          console.log(data);
          setProduct(data);
        } catch (error) {
          console.error('Error fetching Product:', error);
        }
      };
      if(postID !== null){
        fetchProduct();
        //setThumbsSwiper(null);
      };
    }, [postID]);

    if(!product){
      return <div className='loading' style={{height: '150px'}}></div>;
    }

    console.log(product);

    return (
      <>
      {(props.inCatalog) ? (<button aria-label="Close product" className="close-button" onClick={() => {props.setActiveProduct(null)}}>Close</button>) : null }
      <header className={product.acf && product.acf.nutritional_label ? "product__header" : "product__header product__header--no-gallery"} >
        <div className="header__gallery-thumbs">
          <Swiper
              onSwiper={setThumbsSwiper}
              spaceBetween={2}
              slidesPerView={(product.acf.product_images_thumbnails?.length > 0) ? product.acf.product_images_thumbnails?.length : 3}
              watchSlidesProgress={true}
              modules={[Thumbs]}
              className="galleryThumbs vertical-thumbs"
              direction="horizontal"
              breakpoints={{
                768: {
                  direction:"vertical",
                  spaceBetween: 10,
                  slidesPerView: (product.acf.product_images_thumbnails?.length > 0) ? product.acf.product_images_thumbnails.length : 3
                }
              }}
          >
            {product.acf && product.acf.product_images_thumbnails?.length ? 
              (
                  <>
                    {product.acf.product_images_thumbnails.map((image, index) => (
                      <SwiperSlide key={index} >
                        <img src={image[0]} width={image[1]} height={image[2]} />
                      </SwiperSlide>
                    ))}
                  </>
                ) : 
                (
                  <SwiperSlide>
                    <img src={product._embedded['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url} width={150} height={150} />
                  </SwiperSlide>
                )
            }
            <SwiperSlide>
              <img src={nf_thumb} width={150} height={150} />
            </SwiperSlide>
          </Swiper> 
        </div>
      
        <div className="header__gallery zoom-father">
          {product.acf && product.acf.product_images ? 
            (
              <Swiper
                spaceBetween={10}
                navigation={false}
                modules={[Thumbs, Zoom]}
                thumbs={{ swiper: thumbsSwiper }}
                className="gallerySwiper"
                zoom={true}
              >
                {product.acf.product_images.map((image, index) => {
                  return (
                    <SwiperSlide key={index} >
                        {/* <Zoom src={image[0]} width={image[1]} height={image[2]} minusHeight={50}/> */}
                        <div className="swiper-zoom-container">
                          <img src={image[0]} width={image[1]} height={image[2]} />
                        </div>
                    </SwiperSlide>
                  )
                })}
                <SwiperSlide>
                  <NutritionalLabel nf={product.acf.nutritional_label}/>
                </SwiperSlide>
              </Swiper>
            ) 
            : 
            (
              <Swiper 
                className="gallerySwiper"
                modules={[Thumbs, Zoom]}
                thumbs={{ swiper: thumbsSwiper }}
                zoom={true}
              >
                <SwiperSlide >
                  <div className="swiper-zoom-container">
                    <img src={product.featured_image_src[0]} width={product.featured_image_src[1]} height={product.featured_image_src[2]} />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <NutritionalLabel nf={product.acf.nutritional_label}/>
                </SwiperSlide>
              </Swiper>
              // <Zoom src={product.featured_image_src[0]} width={product.featured_image_src[1]} height={product.featured_image_src[2]} minusHeight={50}/>
            ) }
          <div className='hover-on-image'>Click or pinch image to expand image</div>
        </div>
      
        <ProductInfo product={product} root_props={props}/>
      </header>
      {/* Activate when component below is complete and move into the slider */}
      {/* <NutritionalLabel labels={product.acf.nutritional_label} /> */}
      <footer className="product__footer">
          <div className="footer__title">
            <h2 dangerouslySetInnerHTML={{ __html : product.featured_in_recipes_title}}></h2>
          </div>
        
          <Swiper
              className='figure-mouseover'
              slidesPerView={1}
              loop={false}
              breakpoints={{
                500: {
                  slidesPerView: product.featured_in_recipes.length > 3 ? 3 : product.featured_in_recipes.length,
                },
              }}
          >
          {product.featured_in_recipes.map((recipe, index) => (
              <SwiperSlide key={index} >
                <a href={recipe.permalink} aria-label="View recipe">
                  <figure 
                    //style={{ 'height' : minHeight}}
                    //style={{ 'maxHeight' : '450px'}}
                  >
                    <img src={recipe.featured_image_url} width={recipe.width} height={recipe.height}/>
                    <figcaption dangerouslySetInnerHTML={{ __html : recipe.post_title }}></figcaption>
                  </figure>
                </a>
              </SwiperSlide>
            )
          )}
          </Swiper>
      </footer>
      </>
    )
} 

const ProductInfo = ({product, root_props}) => {
  const [claims, setClaims] = useState([]);

  const handleBackbutton = (terms) => {
    //Recieved term-id of product-category taxonomy
    if(root_props.inCatalog){
      // Inside product_catalog
      root_props.setActiveProduct(null);
    } else{
      // Individual page
      const slugs = terms.map(term => term.slug);
      window.location.href=`/products?type=${slugs.join(',')}`;
    }
  }

  const handlePrint = () => {
    window.addEventListener("beforeprint", () =>{
      console.log('before print');
    });
    window.print();
  }

  const handleShare = async () => {
    try {
      await navigator.share({
        title: product.title.rendered,
        text: 'Check out this product!',
        url: product.link.replace('http://','https://'),
      });
    } catch (error) {
      // navigator.clipboard.writeText(product.link.replace('http://','https://'));
      // alert('Web Share API is not supported in this browser or context. Product link was copied to clipboard instead');
      alert('Web Share API is not supported in this browser or context.');
      console.error('Error sharing:', error);
    }
  };
  
  const handleBuyNow = () => {
    const buy_link = product.acf.buy_now_link;
    if(buy_link){
      window.location.href = buy_link;
    } else {
      alert("No 'buy now' link provided by client");
    }
  }

  useEffect(() => {
    setClaims(getClaimsIcons(product.acf.product_claims));
  },[product])

  let product_size_formatted = '';
  if(product.acf?.product_size){
    // product_size_formatted = "<span class='sans-serif'>" + product.acf?.product_size.replace(' ','</span> ');
    product_size_formatted = product.acf.product_size;
  }

  return (
    <div className="header__copy">
      {/* For Print */}
      <img className='print-logo' width={174} height={114} src={myTheme.logoUrl} alt="Site Logo" />
      <img className='print-product' width={200} height={200} src={product.featured_image_src[0]} alt="Product Image" />
      {/* For Print */}
      <div className="product__top-buttons">
        <button aria-label="Show products of the same category" className="term-button" onClick={()=>handleBackbutton(product.taxonomy_info['product_category'])} dangerouslySetInnerHTML={{ __html:product.taxonomy_info['product_category'][0].label}}></button>
        <div className="icon-buttons">
          <button aria-label="Print product sheet" className="print-button" onClick={() => handlePrint()}>Print</button>
          <button aria-label="Share product" onClick={handleShare} className="share-button">Share</button>
        </div>
      </div>
      <div className="product__size" dangerouslySetInnerHTML={{ __html: product_size_formatted}}></div>
      <h1 dangerouslySetInnerHTML={{ __html : product.title.rendered}}></h1>
      <button className={product.acf.buy_now_link ? 'buynow' : 'buynow hide'} onClick={() => handleBuyNow()}>Buy Now</button>
      <div className="product__content" dangerouslySetInnerHTML={{__html : product.content.rendered}}></div>
      <div className="product__ingredients">
        <h4>Ingredients:</h4>
        <p>{product.acf.product_ingredients}</p>
      </div>
      <div className="product__upc">
        UPC: <span className='sans-serif'>#0{product.acf.product_upc}</span>
      </div>
      <div className="product__claims">
        {claims.length > 0 ? (
          claims.map((claim, index) => (
            <div key={index} className='tooltip-box'>
              <img src={claim[0]} alt={claim[1]} />
              <span className='tooltip-text'>{claim[1]}</span>
            </div>
          ))
        ) : (
          <p>No claims available</p>
        )}
      </div>
      <div className="product__tips">
        Tip: {product.acf.product_tips}
      </div>
    </div>
  )
}

import gf from '../icons/gf.svg';
import madeinusa from '../icons/made-in-usa.svg';
import recyclable from '../icons/recycle.svg';
import nonbpa from '../icons/non-bpa.svg';
import nongmo from '../icons/non-gmo.svg';
// import nongmo from '../icons/nongmo.webp';
// import verylowsodium from '';
import hfcs from '../icons/HFCS.svg';
import lowsodium from '../icons/lowsodium.svg';
import nosodium from '../icons/nosodium.svg';
import kosher from '../icons/kosher.svg';
import lowfat from '../icons/lowfat.svg';
import nopreservatives from '../icons/no-preservatives.svg';
import vegan from '../icons/vegan.svg';

function getClaimsIcons(claims_array){
  let temp = []
  let missing_claims = [...claims_array];
  console.log(missing_claims);
  claims_array.forEach((claim) => {
    console.log(claim);
    switch (claim){
      case 'gf':
        temp.push([gf, 'Gluten Free']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break;
      case 'made-in-usa':
        temp.push([madeinusa, 'Made in USA']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break;
      case 'non-bpa':
      case 'bpa':
        temp.push([nonbpa, 'BPA-free liner']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break;
      case 'non-gmo':
      case 'gmo':
        temp.push([nongmo, 'No GMOs']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break;
      case 'recyclable':
      case 'recycle':
        temp.push([recyclable, 'Recyclable container']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break;
      case 'very-low-sodium':
        temp.push([lowsodium, 'Very low sodium']) ;
        missing_claims.pop(missing_claims.indexOf(claim))
        break;
      case 'low-sodium':
        temp.push([lowsodium, 'Low sodium']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break;
      case 'no-sodium':
        temp.push([nosodium, 'No sodium']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break;
      case 'kosher':
        temp.push([kosher, 'OU Kosher Certified']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break;
      case 'no-preservatives':
      case 'preservatives':
        temp.push([nopreservatives, 'No Preservatives']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break;
      case 'low-fat':
      case 'fat':
        temp.push([lowfat, 'Low Fat']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break; 
      case 'vegan':
        temp.push([vegan, 'Vegan']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break; 
      case 'hfcs':
        temp.push([hfcs, 'No High Fructose Corn Syrup']) ;
        missing_claims.splice(missing_claims.indexOf(claim), 1);
        break; 
      default:
        break;
    }
    console.log(missing_claims);
  })
  if(temp.length != claims_array.length){
    console.log("Error: missing some claims", missing_claims);
  }
  return temp;
}

export default Product;